import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLongArrowDownBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 9,
	viewBox: "0 0 9 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 1C5 0.447715 4.55228 0 4 0C3.44772 0 3 0.447715 3 1V6.58579L1.70711 5.29289C1.31658 4.90237 0.683417 4.90237 0.292893 5.29289C-0.0976311 5.68342 -0.0976311 6.31658 0.292893 6.70711L3.29289 9.70711C3.68342 10.0976 4.31658 10.0976 4.70711 9.70711L7.70711 6.70711C8.09763 6.31658 8.09763 5.68342 7.70711 5.29289C7.31658 4.90237 6.68342 4.90237 6.29289 5.29289L5 6.58579V1Z",
		fill: "currentcolor"
	})
});
export default SvgLongArrowDownBold;
